import { render, staticRenderFns } from "./serveChat.vue?vue&type=template&id=6459c859&scoped=true&"
import script from "./serveChat.vue?vue&type=script&lang=js&"
export * from "./serveChat.vue?vue&type=script&lang=js&"
import style0 from "./serveChat.vue?vue&type=style&index=0&id=6459c859&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6459c859",
  null
  
)

export default component.exports